import React from "react";
import { PieChart } from "react-feather";
import { BarChart, Bar, XAxis, ResponsiveContainer, Cell, Tooltip as RechartsTooltip } from "recharts";
import { TypeTooltip } from "./ChartTooltips";
import styles from "../../maintenancerequest.module.css";

// data: [{ label, count, color }]
const RequestsByTypeChart = ({ data, year, loading }) => {
    const totalRequests = data.reduce((sum, t) => sum + (t.count || 0), 0);

    return (
        <div className={`${styles.widgetCard}`}>
            <div className={`${styles.widgetHead}`}>
                <div className={`${styles.widgetTitleWrap}`}>
                    <div className={`${styles.widgetIcon} ${styles.wiPurple}`}>
                        <PieChart size={16} />
                    </div>
                    <div>
                        <div className={`${styles.widgetTitle}`}>Requests by Type</div>
                        <div className={`${styles.widgetSub}`}>All properties · {year}</div>
                    </div>
                </div>
                <div className={`${styles.widgetStat}`}>
                    {loading ? "-" : totalRequests}
                    <span className={`${styles.widgetStatLabel}`}>total</span>
                </div>
            </div>
            <div className={`${styles.chartBox}`}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                        <XAxis
                            dataKey="label"
                            tickLine={false}
                            axisLine={false}
                            tick={{ fill: "#70707d", fontSize: 12, dy: 6 }}
                        />
                        <RechartsTooltip content={<TypeTooltip />} cursor={{ fill: "rgba(92,53,201,0.06)" }} />
                        <Bar dataKey="count" radius={[6, 6, 0, 0]} maxBarSize={28}>
                            {data.map((t) => (
                                <Cell key={t.label} fill={t.color} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default RequestsByTypeChart;